import { CommonModule } from '@angular/common';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnInit} from '@angular/core';
import { HTTPSearchResultTourMap } from 'src/app/models';
import { TourViewLinkService } from 'src/app/services/tour-view-link.service';
import { HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig } from '../../../config/hotel-tours-list-page.config';
import { HotelStarsComponent } from '../../hotel-stars/hotel-stars.component';
import { HotelServicesComponent } from '../../tours/tour-info/hotel-services/hotel-services.component';
import { PriceFormatPipe } from '../../pipes/price-format/price-format.pipe';

@Component({
  selector: 'app-map-popup-hotel',
  templateUrl: './map-popup-hotel.component.html',
  styleUrls: ['./map-popup-hotel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    HotelStarsComponent,
    HotelServicesComponent,
    PriceFormatPipe
  ],
})
export class MapPopupHotelComponent implements OnInit {
  @Input() tour: HTTPSearchResultTourMap;

  messages: any = {};

  constructor(
      @Inject(HOTEL_TOURS_PAGE_CONFIG) private appConfig: HotelToursPageConfig,
      private tourViewLink: TourViewLinkService,
      private cdRef: ChangeDetectorRef,
  ) {
    this.messages = {
      viewTour: this.appConfig.translates.viewTour,
    };
  }

  ngOnInit() {
  }

  get photo(): string {
    return this.tour.photo
        ? `url(https://static.ht.kz/img/h/sm4x3/${this.tour.photo})`
        : 'url(https://ht.kz/img/no-hotel.jpg)';
  }

  get hotelTitle(): string {
    return `${this.tour.hotel} ${this.tour.stars || this.tour.hotelClass}*`;
  }

  get bookingRating(): string {
    if (Number(this.tour.rating) === 10) {
      return '10';
    }

    return this.tour.rating % 1 === 0 ? `${this.tour.rating}.0` : `${this.tour.rating}`;
  }

  get touristsText(): string {
    const children = this.tour.children ?? this.tour.childAges?.length ?? 0;
    const messages = this.appConfig.translates.tourPrices;
    const template: string = children > 0 ? messages['touristsCountWithChildren'] : messages['touristsCount'];
    return template.replace('{{adults}}', String(this.tour.adults)).replace('{{children}}', String(children));
  }

  openTour(): void {
    window.open(this.tourViewLink.getHref(this.tour), '_blank', 'noopener');
  }

  detectChanges(): void {
    this.cdRef.detectChanges();
  }
}

